import { Box } from '@chakra-ui/react'
import { type ReactNode } from 'react'
import InternalAppShell from '../../../../../components/InternalAppShell'

interface Props {
  isCentered?: boolean
  title?: ReactNode
  contentMode?: 'default' | 'wide' | 'full' | 'workspace'
}

export default function BasePageLayout({
  children,
  isCentered,
  title,
  contentMode = 'default'
}: WithChildren<Props>) {
  return (
    <InternalAppShell title={title} contentMode={contentMode}>
      <Box
        w="full"
        maxW={
          isCentered ? (contentMode === 'wide' ? '1240px' : '960px') : undefined
        }
        mx={isCentered ? 'auto' : undefined}
        display="flex"
        flexDirection="column"
        gap={isCentered ? 6 : 0}
      >
        {children}
      </Box>
    </InternalAppShell>
  )
}
